import React, { useState } from 'react';
import { Modal } from 'antd';

import { withTranslation } from 'react-i18next';
import DataTable from './DataTable';
import { BatchDetailsContainer } from './batchDetailsStyles';
import BatchFilters from './BatchFilters';

const NAMESPACES = ['PRINT_FAILURE_TABLE'];

const BatchDetails = props => {
  const { batchData, startAndEndDate, onCancel, t } = props;
  const [filterSection, setFilterSection] = useState(false);

  return (
    <Modal
      width={'98%'}
      centered
      closable={true}
      placement="right"
      onCancel={() => onCancel()}
      visible={true}
      footer={[]}
      className="mailRoomDoc_modal"
    >
      <BatchDetailsContainer filterSection={filterSection}>
        <div className="title">{batchData.batchName}</div>
        {batchData && (
          <BatchFilters
            filterSection={filterSection}
            setFilterSection={setFilterSection}
            batchData={batchData}
            startAndEndDate={startAndEndDate}
          />
        )}
        <DataTable tableData={batchData.files} />
      </BatchDetailsContainer>
    </Modal>
  );
};

export default withTranslation(NAMESPACES)(BatchDetails);
